module.exports = __webpack_public_path__ + "static/media/Woodhouse-Day-Spa.ee8d22c8.pdf";